
import React, { useState } from 'react';
import {
  Table, Thead, Tbody, Tr, Th, Td, Button,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  useDisclosure, Badge, Flex,
  Box
} from '@chakra-ui/react';
import SolicitudObstruccionTemporal from '../Ventanas/RegistroMultaObstruccion';

const TablaSolicitudObstruccionTemporal: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isOpenEdit, onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();

  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const data = Array.from({ length: 8 }, (_, i) => ({
    id: i + 1,
    descripcion: 'SolicitudObstruccionTemporal ejemplo ' + (i + 1),
    estatus: i % 3 === 0 ? 'Aprobado' : (i % 2 === 0 ? 'Cancelado' : 'En proceso'),
    responsable: 'Usuario ' + (i + 1),
  }));

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  const handleRowClick = (item: any) => {
    setSelectedItem(item);
    onOpen();
  };

  const handleRowClickEdit = (item: any) => {
    setSelectedItem(item);
    onOpenEdit();
  };

  const getBadgeColor = (estatus: string) => {
    switch (estatus) {
      case 'Aprobado': return 'green';
      case 'En proceso': return 'yellow';
      case 'Cancelado': return 'red';
      default: return 'gray';
    }
  };

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white" p={4}>
    <Table variant="simple" size="sm">
      <Thead bg="#5b182b">
          <Tr>
            <Th color="white">ID</Th>
            <Th color="white">Descripción</Th>
            <Th color="white">Responsable</Th>
            <Th color="white">Estatus</Th>
            <Th color="white">Acciones</Th>
          </Tr>
        </Thead>
        <Tbody>
          {currentItems.map((item) => (
            <Tr key={item.id}>
              <Td>{item.id}</Td>
              <Td>{item.descripcion}</Td>
              <Td>{item.responsable}</Td>
              <Td>
                <Badge colorScheme={getBadgeColor(item.estatus)}>{item.estatus}</Badge>
              </Td>
              <Td>
                <Button size="sm" onClick={() => handleRowClick(item)}>Ver</Button>
              </Td>
              <Td>
                <Button size="sm" onClick={() => handleRowClickEdit(item)}>Editar</Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Flex mt={4} justify="center" gap={2}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i + 1}
            size="sm"
            colorScheme={currentPage === i + 1 ? 'blue' : 'gray'}
            onClick={() => paginate(i + 1)}
          >
            {i + 1}
          </Button>
        ))}
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Ver SolicitudObstruccionTemporal</ModalHeader>
          <ModalBody>
            <SolicitudObstruccionTemporal modo="view" data={selectedItem} />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={onClose}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenEdit} onClose={onCloseEdit} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Editar SolicitudObstruccionTemporal</ModalHeader>
          <ModalBody>
            <SolicitudObstruccionTemporal modo="edit" data={selectedItem} />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={onCloseEdit}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TablaSolicitudObstruccionTemporal;
